import { DIRECT_DEBIT_PAYMENT_TRANSACTION_CODES } from '../data/direct-debit-payment.data';

export type DirectDebitPaymentTransactionCode = typeof DIRECT_DEBIT_PAYMENT_TRANSACTION_CODES[number]['id'];
export type DirectDebitPaymentReportType = 'selection' | 'submission';
